import React from 'react';

import { PageTitle } from '../../../components';
import { Process } from '../../../sections';


const ProcessPage = () => { 

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Process'} page={'Process'} />

      <Process />
 
    </>
  )
}

export default ProcessPage;